<template>
  <!-- contract manage -->
  <div>
    <div class="org-tree">
      <p class="title">---- 企业成员的合同 ----</p>
      <!-- contract tree -->
      <el-tree
        class="tree-style contract-tree"
        :data="treeGroup"
        :highlight-current="false"
        :expand-on-click-node="false"
        node-key="corpGroupId"
        :default-expand-all="true"
        :props="defaultProps"
        @node-click="handleNodeClick"
        ref="contractTree"
      >
        <div
          slot-scope="{ node, data }"
          class="wrap"
          :title="`${data.groupName}${
            filterModel.departmentId === data.corpGroupId
              ? `(${filterModel.pageTotal}份)`
              : ''
          }`"
        >
          <p
            :class="
              filterModel.departmentId === data.corpGroupId
                ? 'name'
                : 'name-full'
            "
          >
            {{ data.groupName }}
          </p>
          <span
            v-if="
              filterModel.departmentId === data.corpGroupId &&
              filterModel.pageTotal > 99
            "
            class="count"
            >(99<sup>+</sup>份)</span
          >
          <span
            v-if="
              filterModel.departmentId === data.corpGroupId &&
              filterModel.pageTotal <= 99
            "
            class="count"
            >({{ filterModel.pageTotal }}份)</span
          >
        </div>
      </el-tree>
      <!--      是否有主体合同查看的权限-->
      <div v-if="perms.includes(17) && currentAuthUser.corpUserId">
        <p class="title">---- 企业主体的合同 ----</p>
        <div
          :class="[
            'choose_item',
            { active_choose_item: enterpriseSubjectType === 2 },
          ]"
          @click="changeListFn(2)"
        >
          待签的
        </div>
        <div
          :class="[
            'choose_item',
            { active_choose_item: enterpriseSubjectType === 3 },
          ]"
          @click="changeListFn(3)"
        >
          已结束的
        </div>
        <div
          :class="[
            'choose_item',
            { active_choose_item: enterpriseSubjectType === 1 },
          ]"
          @click="changeListFn(1)"
        >
          发给他人的
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ApiMethods } from "@/assets/js/http-serve/http-methods";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import Bus from "@/plugins/bus.js";
import ElGo from "../../components/go/Go";
import { mapGetters } from "vuex";

export default {
  name: "contract",
  components: {
    ElGo
  },
  data () {
    return {
      treeGroup: [],
      cSDialogVisible: false, //证书弹出框显示
      cSDialogData: {}, //证书弹出框数据
      sSDialogVisible: false, // 请选择出证主体身份弹出框显示
      sSDialogData: {}, //请选择出证主体身份数据
      selectContract: [],
      selectTreeNode: {}, // 选中的树节点
      defaultProps: {
        children: "childCorpGroups"
      },
      // filter model
      filterModel: {
        departmentId: "", // 部门id
        keywordType: 1, // 1 合同名称, 2 发起人, 3 签署人
        keyword: "",
        status: "",
        timePicker: "",
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      enterpriseSubjectType: 0,
    };
  },
  created () {
    this.eventFun();
  },
  mounted () {
    this.initTreeGroup();
  },
  computed: {
    ...mapGetters(["currentAuthUser"]),
    perms () {
      const perms = this.$store.getters.consoleToken;
      return perms ? perms.perms : [];
    },
  },
  methods: {
    //企业主体
    changeListFn (val) {
      this.enterpriseSubjectType = val;
      Bus.$emit("enterpriseSubjectEmit", val);
      this.$nextTick(() => {
        if (this.$refs.contractTree && this.$refs.contractTree.$el) {
          let firstTreeItem = this.$refs.contractTree.$el.querySelector(
            ".is-current"
          );
          firstTreeItem && firstTreeItem.classList.remove("is-current");
        }
      });
    },
    // 创建监听事件
    eventFun () {
      Bus.$on("$formateTree", obj => {
        let { number, filterModel } = obj;
        this.filterModel = filterModel;
        this.treeGroup = this.convertFormateTree(this.treeGroup, number);
      });
    },
    // convert data for tree formate
    // 转换成tree需要的数据格式
    convertFormateTree (data, number) {
      data.forEach(element => {
        element.label = element.groupName;
        if (
          number !== undefined &&
          this.filterModel.departmentId === element.corpGroupId
        ) {
          this.$set(element, "label", element.groupName + `(${number}份)`);
        }
        if (element.childCorpGroups) {
          this.recursionChildren(element.childCorpGroups, number);
        }
      });
      return data;
    },
    recursionChildren (childCorpGroups, number) {
      childCorpGroups.forEach(element => {
        element.label = element.groupName;
        if (
          number !== undefined &&
          this.filterModel.departmentId === element.corpGroupId
        ) {
          element.label = element.groupName + `(${number}份)`;
        }
        if (element.childCorpGroups) {
          this.recursionChildren(element.childCorpGroups, number);
        }
      });
    },
    // init org staructure data
    // 初始化组织机构数据
    async initTreeGroup () {
      let params = {};
      params.permId = 5;
      ApiCorpMethods.OrganizationController.treeGroup(params)
        .then(async res => {
          if (res.code === "0") {
            this.treeGroup = await this.convertFormateTree(res.data);
            this.$nextTick(() => {
              if (this.$refs.contractTree && this.$refs.contractTree.$el) {
                let firstTreeItem = this.$refs.contractTree.$el.querySelector(
                  "div"
                );
                firstTreeItem && firstTreeItem.classList.add("is-current");
              }
            });
            if (this.treeGroup && this.treeGroup.length > 0) {
              let firstElement = this.treeGroup[0];
              this.selectTreeNode = firstElement; // 赋初值
              this.filterModel.departmentId = firstElement.corpGroupId;
              Bus.$emit("$queryContarct", {
                selectTreeNode: firstElement,
                filterModel: this.filterModel
              });
            }
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          console.info(error);
          this.$message.error(error.description);
        });
    },
    // tree node click event
    // 点击节点触发事件
    handleNodeClick (data) {
      this.enterpriseSubjectType = 0;
      if (data && data.corpGroupId) {
        this.selectTreeNode = data;
        this.filterModel.departmentId = data.corpGroupId;
        this.filterModel.itemPage = 1;
        Bus.$emit("$queryContarct", {
          selectTreeNode: data,
          filterModel: this.filterModel
        });
        this.$nextTick(() => {
          if (data.corpGroupId !== this.treeGroup[0].corpGroupId) {
            if (this.$refs.contractTree && this.$refs.contractTree.$el) {
              let firstTreeItem = this.$refs.contractTree.$el.querySelector(
                "div"
              );
              firstTreeItem && firstTreeItem.classList.remove("is-current");
            }
          }
        });
      }
    }
  } // methods end
};
</script>

<style lang="less">
@import url("../../assets/style/cssVariable.less");
.tree-style .el-tree-node.is-current > .el-tree-node__content {
  background-color: @ebq-left-selected;
  color: @ebq-red;
}
</style>
<style lang="less" scoped>
.wrap {
  width: calc(100% - 40px);
  font-size: 0;
  margin-left: 5px;

  .name {
    width: 100%;
    max-width: calc(100% - 50px);
    float: left;
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    font-size: 14px;
  }

  .name-full {
    width: 100%;
    float: left;
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    font-size: 14px;
  }

  .count {
    float: left;
    font-size: 14px;
  }
}

.org-tree {
  border-radius: 2px;
  background: #ffffff;
  overflow: auto;
  .title {
    text-align: center;
    margin: 10px 0;
  }
}
.choose_item {
  text-align: center;
  color: #606266;
  cursor: pointer;
  margin: 6px 0;
  padding: 4px 0;
  &.active_choose_item {
    background-color: #d3ddea;
  }
}
</style>



// WEBPACK FOOTER //
// components/signInfo/contractTabLeft.vue